import { Route, Redirect, useLocation, Switch } from 'react-router-dom'
import { ToastContainer } from 'react-toastify'
import uniqueId from 'lodash-es/uniqueId'
import { Loader } from '../../components/common'
import { ROUTES, NAV_LINKS } from '../../constants/NavConstants'
import * as pages from '..'
import { PrimaryNavigation, SecondaryNavigation } from '../../components/navigation'
import NoAccessRoute from '../../components/routes/NoAccessRoute'
import useCatapultAuth from '../../hooks/useCatapultAuth'
import 'react-toastify/dist/ReactToastify.css'

const mapStateToProps = state => state.user

const MainAppRoute = ({ Component, hasAccess, pathname, search }) => {
  let redirect = null
  if (!hasAccess) {
    redirect = NAV_LINKS.noaccess
  }

  if (redirect && pathname !== redirect) {
    return <Redirect to={{ pathname: redirect, search }} />
  }

  return (
    <div>
      <PrimaryNavigation />
      <SecondaryNavigation />
      <div className="skipwrapper">
        <a id="main" tabIndex="-1">
          -
        </a>
      </div>
      <div style={{ marginTop: '1.5em' }}>
        <Component />
      </div>
      <ToastContainer />
    </div>
  )
}

const AppRoutes = ({ isAuthenticating, hasAccess }) => {
  const { search, pathname } = useLocation()
  const { isAuthed } = useCatapultAuth()

  useEffect(() => {
    if (!/scroll/.test(search)) {
      window.scrollTo(0, 0)
    }
  }, [])

  if (isAuthenticating) {
    return <Loader />
  }

  if (!isAuthenticating && !isAuthed) {
    return <Redirect to={{ pathname: NAV_LINKS.login, search }} />
  }

  return (
    <Switch>
      <NoAccessRoute path={NAV_LINKS.noaccess} />
      {ROUTES.map(r => (
        <Route
          exact
          path={r.path}
          component={() => (
            <MainAppRoute
              Component={pages[r.component]}
              hasAccess={hasAccess}
              search={search}
              pathname={pathname}
            />
          )}
          key={uniqueId()}
        />
      ))}
      <Route component={pages.NotFoundPage} />
    </Switch>
  )
}

export default connect(mapStateToProps)(AppRoutes)
